/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {useEffect, useState} from 'react';
import {View} from 'react-native';
import {connect} from 'react-redux';
import mapDispatchToProps from '../../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../../services/redux/mapStateToProps';
import {HeaderScreen} from '../../../components/Header/HeaderScreen';
import {formsStyles} from '../../../components/Inputs/formStyles';
import {Loader} from '../../../components/Loader';
import {HistoriquePayement} from '../../../components/Paiement/Historique';

export function PayementListScreen(props: any) {
  const [isLoading, setIsLoading] = useState(false);
  const {historiquePaiementUser, user} = props;
  useEffect(() => {
    setIsLoading(true);
    historiquePaiementUser({}, () => {
      setIsLoading(false);
    });
  }, []);

  return (
    <View style={{flex: 1}}>
      <HeaderScreen
        title="Compte > Historique des paiements"
        type="GoToMonEspace"
        noBreadcrumb={false}
      />
      <View style={[formsStyles.webformContain, {flex: 1}]}>
        <View style={formsStyles.formContain}>
          {isLoading ? (
            <Loader />
          ) : (
            <HistoriquePayement data={user && user.listPaiement} />
          )}
        </View>
      </View>
    </View>
  );
}

export const PayementList = connect(
  mapStateToProps,
  mapDispatchToProps,
)(PayementListScreen);
